export enum NotesType {
    SALES_NOTE = 0,
    CUSTOMER_SERVICE_NOTE = 1,
    OPPORTUNITY_NOTE = 3,
    COLLECTION_NOTE = 2,
    LANDLORD_NOTE = 4,
    UNDERWRITING_NOTE = 5
}


// WEBPACK FOOTER //
// ./src/app/models/notes/notes.type.ts